/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "agentPayRestApi",
            "endpoint": "https://p0g3a7otj3.execute-api.eu-west-2.amazonaws.com/agentpay",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:1d4bc5d2-e049-4c32-a7f5-77f4ab586acd",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_1TdBizCDV",
    "aws_user_pools_web_client_id": "54tae6939m641ife7eph8efe7e",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ]
};


export default awsmobile;
